define('gameday-index-url-hasher/UrlHasher',['require','exports','module','extant/extant','message-service/message-service','gameday-index-enums/enums/baseball/GameStates','./enums/HashEvents','gameday-index-enums/enums/baseball/GIDDecoder','./querySyntax'],function(require, exports, module) {

	var exists = require("extant/extant"),
		MessageService = require("message-service/message-service"),
		GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
		HashEvents = require("./enums/HashEvents"),
		GID = require("gameday-index-enums/enums/baseball/GIDDecoder");

	var instance = null,
		regexHash = /#.*|$/,
		regexSplit = /[,&]/,
		lastParamState = {},
		paramCache = {};

	var SEP = require("./querySyntax")();

		// Hash param descriptor objects
	var paramMap = {
		game 	: {
			evt : HashEvents.GAME_ID_CHANGED,
			protect : true
		},
		gid 	: {
			alias : 'game'
		},
		game_state 	: {
			evt : HashEvents.GAME_STATE_CHANGED
		},
		game_tab  : {
			evt : HashEvents.SELECTED_TAB_CHANGED
		},
		tab  : {
			alias : 'game_tab'
		},
		tfsHold  : {
			evt : HashEvents.TFS_HOLD_SWITCHED
		},
		tfsPause : {
			alias : 'tfsHold'
		},
		eggs : {
			evt : HashEvents.EGGS
		},
		// Nothing to really do here, just whitelist it.
		// @see enforceLockState
		lock_state : {},
		tfs : {
			evt : HashEvents.TFS_TIME_CHANGED
		},
		tfsTime : {
			alias : 'tfs'
		}
	}

	function UrlHasher() {
		var poo = "doodie";
	}

	UrlHasher.prototype = {
		getHashParams: function() {
			this.checkState();
			return paramCache;
		},

		getCachedParams: function() {
			return $.extend({}, paramCache);
		},

		removeHashParam: function(key) {
			var pars = getParams();
			delete pars[key];

			return writeHash(pars);
		},

		setHashParams: function($pars) {
			setParams($pars);
		},

		setInitParams: function(rawparams, gid) {
			// make sure there's something to inspect
			if (!exists(rawparams)) {
				rawparams = {};
			}

			// if we have a gid and no game on the object
			if (exists(gid) && !exists(rawparams.game)) {
				var gidVO = new GID(gid);
				rawparams.gid = GID.gid;
			}
			// add game id to the params

			var key,
				params = {},
				mappedParam;

			for (key in rawparams) {
				mappedParam = getMappedParam(key);
				if(mappedParam.value){
					params[mappedParam.key] = rawparams[key];
				}
			}
			setParams(params);

			if (window.addEventListener) {
				var listener = this.checkState;
				window.addEventListener('hashchange', function(e) {
					listener(e);
				});
			}
		},

		checkState: function(e) {
			if (e) {
				e.preventDefault();
			}

			var params = getParams(),
				changedKeys = [],
				paramDiff = {},
				key;

			// If we have to change the game_state to match
			// the lock state, quit this op and try again
			// with the fixed params
			if (enforceLockState(params)) {
				setParams(params);
				return;
			}
			lastParamState = paramCache;
			paramCache = params;

			for (key in params) {
				if (!lastParamState.hasOwnProperty(key)
					|| (lastParamState.hasOwnProperty(key)
					&& lastParamState[key] !== params[key])) {
					changedKeys.push(key);
					paramDiff[key]=params[key];
				}
			}
			// console.info('check state',[lastParamState,params,paramDiff,changedKeys]);
			if(changedKeys.length){
				MessageService.publish(HashEvents.UPDATE,paramDiff);
				changedKeys.forEach(dispatchHashEvent);
			}

			setParams($.extend({},paramCache));

			return false;
		}
	};

	function getMappedParam(key){
		var mappedParam = paramMap[key],
			alias = key;

		// console.warn(key,mappedParam);
		if(mappedParam && mappedParam.alias){
			alias=mappedParam.alias;
		}
		return {
			key 	: alias,
			value 	: mappedParam
		}
	}
	function getParams(str) {
		var pairs = (str || location.hash).replace('#', '').split(regexSplit),
			len = pairs.length,
			pair,
			mappedParam,
			pars = {},
			key,
			i = 0;

		for (; i < len; i++) {
			pair = pairs[i].split('=');
			mappedParam = getMappedParam(pair[0]);
			key = mappedParam.key;
			pars[key] = pair[1];

			// Ensure we have a value for protected params
			// @see paramMap
			if(mappedParam.value && mappedParam.value.protect){
				if(!pars[key]){
					pars[key]=paramCache[key];
				}
			}
		}

		enforceLockState(pars);
		return pars;
	}

	function enforceLockState(pars) {
		if (pars.lock_state && (pars.game_state !== pars.lock_state)) {
			pars.game_state = pars.lock_state;
			return true;
		}
		return false;
	}

	function setParams($pars) {
		enforceLockState($pars);
		return writeHash($.extend({}, getParams(), $pars));
	}

	function writeHash(params) {
		return location.replace((location + '').replace(regexHash, buildHash(params)));
	}

	function buildHash(_pars) {
		var key,
			ret = [];

		for (key in _pars) {
			ret.push(key + '=' + _pars[key]);
		}

		return "#" + ret.join(SEP);
	}

	function dispatchHashEvent(key) {
		if (paramCache[key] === lastParamState[key]) {
			return true;
		}

		var mappedParam = getMappedParam(key),
			evt = mappedParam.value && mappedParam.value.evt;

		if(evt){
			MessageService.publish(evt, paramCache[mappedParam.key]);
		}
		return true;
	}


	function getInstance() {
		if (!exists(instance)) {
			instance = new UrlHasher();
		}
		return instance;
	}

	return getInstance();
});
